import { ISidebarBannerRequest } from '../../interfaces/Website/SidebarBanner/ISidebarBanner'
import apiService from '../Api'

export default class SidebarBannerService {
  async get() {
    return apiService.get('/sidebar-banner').then(({ data }) => data)
  }

  async update(data: ISidebarBannerRequest) {
    const formData = new FormData()

    // Como PUT precisa de _method no FormData para Laravel
    formData.append('_method', 'PUT')

    if (data.image) {
      formData.append('image', data.image)
    }

    if (data.link_url) {
      formData.append('link_url', data.link_url)
    }

    if (data.is_active !== undefined) {
      formData.append('is_active', data.is_active ? '1' : '0')
    }

    return apiService
      .post('/sidebar-banner', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(({ data }) => data)
  }
}
